import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { MainButton } from '../../Buttons/MainButton';
import CircleLoadingIndicator from '../../LoadingIndicators/CircleLoadingIndicator';
import { REMOVE_USER_LOCATIONS_BY_IDS_MUTATION } from '../../../graphql/apis/user/mutations/userLocation';
import { getGraphqlErrorMessage } from '../../../graphql/utils';
import { UserLocation, setUserLocations } from '../../../redux/user/userSlice';
import { colors } from '../../../theme/colors';
import { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';

interface RemoveUserLocationsButtonProps {
  locationsIds: string[];
  onComplete: () => void;
}

const RemoveUserLocationsButton = ({
  locationsIds,
  onComplete,
}: RemoveUserLocationsButtonProps) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const [removeUserLocations] = useMutation(
    REMOVE_USER_LOCATIONS_BY_IDS_MUTATION,
  );

  const [isRemovingUserLocations, setIsRemovingUserLocations] = useState(false);

  const handleRemoveUserLocations = async (locationsIds: string[]) => {
    if (!locationsIds || locationsIds.length === 0) {
      return;
    }
    setIsRemovingUserLocations(true);

    await removeUserLocations({
      variables: {
        removeUserLocationsInput: {
          locationsIds: locationsIds,
        },
      },
      onCompleted: async (data) => {
        console.log('response', data);
        const locationsData: UserLocation[] = data.removeUserLocations;
        console.log('locationsData', locationsData);
        if (locationsData && locationsData.length) {
          dispatch(setUserLocations(locationsData));

          //   onComplete();
        }
      },
      onError: ({ graphQLErrors, networkError }) => {
        const errorMessage = getGraphqlErrorMessage(
          graphQLErrors,
          networkError,
        );

        console.log('errorMessage', errorMessage);

        console.log('graphQLErrors removeUserLocations', graphQLErrors);
      },
    });

    setIsRemovingUserLocations(false);
  };

  return (
    <MainButton
      fullWidth={isMobileScreen}
      disabled={isRemovingUserLocations}
      typeStyle="danger"
      text={`${t('location.removeLocations')} ${locationsIds.length}`}
      onClick={() => handleRemoveUserLocations(locationsIds)}
      endIcon={
        isRemovingUserLocations ? (
          <CircleLoadingIndicator
            color={colors.textPrimary}
            size={fontSize.xl}
          />
        ) : null
      }
    />
  );
};

export default RemoveUserLocationsButton;
